import { VideoBoardAuthService } from './video-board-auth.service';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { VenuesService } from '../venues/venues.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ToastService } from '../_core/services/toast.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-video-board-auth',
  templateUrl: './video-board-auth.component.html',
  styleUrls: ['./video-board-auth.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonicModule, 
    ReactiveFormsModule
  ]
})
export class VideoBoardAuthComponent implements OnDestroy {
  private activatedRoute = inject(ActivatedRoute)
  private httpClient = inject(HttpClient)
  private venueService = inject(VenuesService)
  private videoBoardAuthService = inject(VideoBoardAuthService)
  private toastService = inject(ToastService)
  private router = inject(Router)
  private translateService = inject(TranslateService)

  form = new FormGroup({
    name: new FormControl<string | null>(null, Validators.required),
    _venueId: new FormControl(null, Validators.required),
    court: new FormControl(null),
    default_view: new FormControl(null),
  })

  venues$ = this.venueService.myVenues();
  venues = toSignal(this.venues$);
  courts:[] = [];

  loaded = computed(() => !! this.venues());

  device$ = this.activatedRoute.params.pipe(
    switchMap(params => 
      this.httpClient.post<any>('api_endpoint' + '/video-board/get-tv', { deviceId: params.deviceId})
    ),
    map(res => res.data)
  )

  private readonly destroy$: Subject<void> = new Subject();


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async authorizeVenue() {
    try{
      if (this.form.invalid) {
        await this.toastService.presentDangerToast(this.translateService.instant('All fields are required'));
        return
      }
      const formObj:any = this.form.value;
      this.activatedRoute.params.pipe(
        takeUntil(this.destroy$),
        switchMap(params => this.videoBoardAuthService.connectVenueWithLocation({...formObj, deviceId:params.deviceId})),
      ).subscribe(device => this.router.navigate(['smart-venues', device.venue._id, 'video-boards'], { replaceUrl: true }))
    } catch (error) {
      await this.toastService.presentDangerToast(this.translateService.instant('Something went wrong while authorizing venue'));
    }
    
  }

  onVenueSelect(event: any) {
    try {
      this.courts = []
      if (event?.detail?.value) { 
        this.venueService.getLocations(event.detail.value).subscribe(
          locations => {
            const {courts} = locations;
            this.courts = courts;
          }, error => {
            this.toastService.presentDangerToast(this.translateService.instant(error?.error?.message || 'Something went wrong while getting courts'));
          }
        )
      } 
    } catch (error) {
      this.toastService.presentDangerToast(this.translateService.instant(error?.error?.message || 'Something went wrong while getting courts'));
    }
  }

}
